<template>
  <div
    @click="readNoti()"
    class="flex-display ai-center pd-b-4 pd-t-4 border-b cursor-pointer width-80 custom-noti"
    :title="!userId?`นักเรียนคนนี้ไม่มีในระบบ`:null"
    :class="!userId?'cursor-not-allowed':'cursor-pointer'"
  >
    <i
      class="fas fa-circle"
      :class="readed ? 'color-gray-lighter' : 'color-warning'"
    ></i>
    <div>
      <div :class="!userId?'cursor-not-allowed':'cursor-pointer'" class="box-image mg-l-4">
        <avatar
          :class="{ facebook: userFrom == 'faceBook' && profileImg == '' }"
          :rounded="false"
          :username="`${nameTH}`"
          :src="
            profileImg
              ? `${urlImage}${userId}/${profileImg}`
              : userFrom == 'faceBook' && profileImg == ''
              ? `https://graph.facebook.com/${profileFrom}/picture?type=small`
              : `${profileFrom}`
          "
          :size="50"
        ></avatar>
      </div>
    </div>
    <div class="flex-display js-between ai-center  width-100 noflex">
      <div class="text-left text-font-14 pd-l-4">
        <p class="mg-y-less">
          {{ `${nameTH} ${surnameTH}` }} <span class="color-warning">{{verbs}}</span>
        </p>
        <p class="mg-y-less">หลักสูตร {{courseName}}</p>
      </div>
      <div class="noti-date">
        <a :class="!userId?'cursor-not-allowed':'cursor-pointer'" class="color-gray text-font-12  ">{{ date | dateTimeTh}}</a>
      </div>
    </div>
  </div>
</template>

<script>
import Avatar from "vue-avatar";
export default {
  components: {
    Avatar,
  },
  props: {
    id: {
      type: String,
      default() {
        return "";
      },
    },
    courseName: {
      type: String,
      default() {
        return "";
      },
    },
    verbs: {
      type: String,
      default() {
        return "";
      },
    },
    date: {
      type: String,
      default() {
        return "";
      },
    },
    readed: {
      type: Boolean,
      default() {
        return false;
      },
    },
    userId:{
      type:String,
      default(){
        return ''
      }
    },
    profileImg:{
      type:String,
      default(){
        return ''
      }
    },
    userFrom:{
      type:String,
      default(){
        return ''
      }
    },
    profileFrom:{
      type:String,
      default(){
        return ''
      }
    },
    nameTH:{
      type:String,
      default(){
        return ''
      }
    },
    surnameTH:{
      type:String,
      default(){
        return ''
      }
    },
  },
  data() {
    return {
      urlImage: process.env.VUE_APP_BASE_URL_IMAGE,
    };
  },
  methods: {
    readNoti() {
      if (this.userId) {
        this.$router.push(`/name/list/course?userId=${this.userId}`);
      }
      
      this.$emit("readNotification", this.id);
    },
  },
};
</script>
